import request from '@/util/request';
import util from "@/util/util";
class team {
  //账号的团队模式类型 
  getTeamModel(self){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.team.model.select",
          data: {
            account_id: util.getCookie("account_id"),
          }
        })
        .then(res => {
          if (res.success) {
              resolve({
                success: true,
                data: res.body
              });
          }else {
            resolve({
              success: false,
              data: {
                code: res.body.code,
                error: res.body.message || res.body.remark
              }
            });
            self.$message.error(res.body.message || res.body.remark);
          }
        });
    });
  }
   //切换团队模式
  postTeamModel(self){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          // action: "kdyserver.team.teammodelswitch",
          action: "kdyserver.team.model.switch",
          data: {
            // account_id: util.getCookie("account_id"),
            // "switch_model": util.getCookie("teamModel")==1?2:1
          }
        })
        .then(res => {
          if (res.success) {
            if (res.success && res.body.code!=500) {
              // debugger
              resolve({
                success: true,
                data: res.body
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  // 增加订单创建人，打印人团队成员筛选
  getTeamInfo(self,data){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.team.getteaminfo",
          data: {
            account_id: util.getCookie("account_id"),
            "team_model": util.getCookie("teamModel")
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
  //查看角色信息
  pretReatment(self){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.team.model.pretreatment",
          data: {},
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
  }
}
export default new team()